// PRODUCT-26110 Task 8b Step 2: no longer installs PortalVue -- Modal.vue/
// ModalTarget.vue were migrated to native <Teleport>, which needs no plugin
// registration at all.
//
// PRODUCT-26110 Task 14: previously installed via the legacy `this.options.Vue.use(...)`
// global singleton (only worked because @vue/compat's runtime provided one) -- now a
// real Vue 3 `Plugin` (`install(app: App)`), applied via `app.use(...)` against the
// actual `createApp()` instance in dashboard-commons/app/internals/Application.ts's
// `mount()`. No cast needed at the call site any more.
import type { App } from 'vue';

import ModalManager from './ModalManager';

function createModalPlugin() {
    return {
        install(app: App): void {
            app.mixin({
                beforeCreate() {
                    if (this === this.$root) {
                        Object.defineProperty(this, '$modalManager', {
                            value: new ModalManager(),
                        });
                    } else {
                        // Object.defineProperty on the public proxy actually writes onto
                        // instance.ctx, so inside the getter `this` is ctx, not the proxy --
                        // and prod-build ctx has no `$root` (only dev's does). Capture the
                        // root here, while `this` is still the proxy, and close over it.
                        const root = this.$root;
                        Object.defineProperty(this, '$modalManager', {
                            get: () => root.$modalManager,
                        });
                    }
                },
            });
        },
    };
}

export default createModalPlugin;
